import React, { FC, ReactElement, ReactNode, RefObject } from 'react'
import { Button } from '@material-ui/core'
import { isStringNotEmpty, isVarNotEmpty } from '../../../../NonReact/utils/GlobalFunctions'
import { redirectToURL } from '../../../../NonReact/utils/LocationUtils'
import { URLConstructor } from '../../../../NonReact/utils/URLBuilder'
import { EMPTY_STRING } from '../../../../NonReact/constants/Common'

type ButtonProps = {
    children: ReactNode
    className?: string
    onClick?: (event: React.MouseEvent) => void
    disabled?: boolean
    download?: undefined
    type?: 'button' | 'submit' | 'reset'
    href?: undefined
    isOutlined?: boolean
    showErrorBadge?: boolean
    shrink?: boolean
    popoverRef?: RefObject<HTMLButtonElement>
}

type AnchorProps = {
    children: ReactNode
    className?: string
    href: string
    onClick?: undefined
    disabled?: boolean
    download?: boolean
    type?: undefined
    isOutlined?: boolean
    showErrorBadge?: boolean
    shrink?: boolean
    popoverRef?: RefObject<HTMLButtonElement>
}

export type RoundedButtonProps = ButtonProps | AnchorProps

export const RoundedButton: FC<RoundedButtonProps> = ({
    children,
    className,
    onClick,
    disabled,
    download,
    type,
    href,
    isOutlined,
    showErrorBadge,
    shrink = false,
    popoverRef
}: RoundedButtonProps): ReactElement => {
    const isAnchor: boolean = isVarNotEmpty(download) && isStringNotEmpty(href)
    const anchorProps: AnchorProps | NonNullable<unknown> = isAnchor
        ? {
              href: href as string,
              download: disabled ? false : download,
              onClick: undefined
          }
        : {
              onClick: isStringNotEmpty(href)
                  ? (): void => redirectToURL(URLConstructor.newInstance({ baseURL: href }))
                  : onClick
          }

    return (
        <Button
            className={`rounded-button ${isOutlined ? 'rb-outlined' : EMPTY_STRING} ${
                showErrorBadge ? 'rb-error-badge' : EMPTY_STRING
            } ${shrink ? 'rb-shrink' : EMPTY_STRING} ${className}`}
            disabled={disabled}
            type={type}
            ref={popoverRef}
            {...anchorProps}
        >
            {children}
        </Button>
    )
}
